const FREQUENCIES = {
    EVERY: 'Every',
    MONTH: 'Month',
    YEAR: 'Year',
    DAY: 'Day',
    WEEK: 'Week',
    availableFrequencies: function(){
        return [this.DAY, this.WEEK, this.MONTH, this.YEAR]
    },
    getFrequencyReadable(notificationInterval){
        let every = isNaN(notificationInterval.every) ? '' : notificationInterval.every;
        let frequency = notificationInterval.frequency.toLowerCase();
        if(every !== '' && every > 1) frequency += 's';
        let text = [this.EVERY,every,frequency].join(' ');

        switch (notificationInterval.frequency) {
            case this.MONTH:
                if(every) text = `${text} (starting on ${notificationInterval.month}, ${notificationInterval.day})`;
                return text;
            case this.WEEK:
                if(every) text = `${text} on ${notificationInterval.day}`;
                return text;
            case this.YEAR:
                return `${text} on ${notificationInterval.month},  ${notificationInterval.day}`;
            default:
                return text;
        }
    }
};

const WEEK_DAYS = {
    MONDAY: 'Monday',
    TUESDAY: 'Tuesday',
    WEDNESDAY: 'Wednesday',
    THURSDAY: 'Thursday',
    FRIDAY: 'Friday',
    SATURDAY: 'Saturday',
    SUNDAY: 'Sunday',
    getWeekDays: function(){
        return [
            this.MONDAY,
            this.TUESDAY,
            this.WEDNESDAY,
            this.THURSDAY,
            this.FRIDAY,
            this.SATURDAY,
            this.SUNDAY
        ];
    }
}


export {
    FREQUENCIES,
    WEEK_DAYS
}

